module.exports = __webpack_public_path__ + "img/integral_banner.54923bec.png";